module.exports = __webpack_public_path__ + "static/media/pMurray.cc713524.jpeg";